export default __webpack_public_path__ + "static/media/bg-set-profile-picture.a04d86b7.png";